(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('itemsInArray', itemsInArray);

    function itemsInArray(lodash) {
        return function(inputs,filterValues, field) {
            if (!(filterValues instanceof Array)) {
                return inputs;
            }
            if (!field) {
                field = 'id';
            }

            var output = [];

            angular.forEach(inputs, function (input) {
                var value = lodash.get(input, field, null);
                if (filterValues.indexOf(input.id) !== -1) {
                    output.push(input);
                }
            });
            return output;
        };
    }
})();